import request from '@/utils/request'

/** 获取下拉框方法 */
export function getSystemSelection(sysId) {
  const data = {
    mainId: sysId
  }
  return request({
    url: `select/getSelectList`,
    method: 'post',
    data
  })
}

/** 获取一级 省级 */
export function getAreaInfo() {
  return request({
    url: `select/getAreaInfo`,
    method: 'post'
  })
}

/** 通过地区编码 获取下级 省市 */
export function getAreaInfoNext(data) {
  return request({
    url: `select/getAreaInfoNext`,
    method: 'post',
    data
  })
}


export function getUsersByRole(data) {
  return request({
    url: 'user/getListByRole',
    method: 'post',
    data
  })
}

export function getYidainToken() {
  return request({
    url: 'https://www.smartelevator.net/platform/api/v1/login',
    method: 'post',
    data: {
      username: 'sys_shmx',
      password: 'i*esa-t0013C',
    }
  })
}
